module.exports = __webpack_public_path__ + "img/login.aeee4126.png";